import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {ToastrService} from "ngx-toastr";
import {NgxSpinnerService} from "ngx-spinner";
import { LogService } from '../../services/log.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(private router: Router,private toastr: ToastrService,private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    const redirectURL = localStorage.getItem('managecard')
    LogService.debug(redirectURL);
    this.toastr.success('Kortet er lagt til', 'Legg til nytt');
    if(redirectURL){
      this.router.navigateByUrl(redirectURL);
    }
    else{
      this.router.navigateByUrl('https://minside.nabonett.no');
    }
  }

}
